import { Flex } from '@frontend/legacy-components';

export const GenericFallbackComponent = () => {
  return (
    <Flex alignItems="center" justifyContent="center">
      An error occurred. Try refreshing the page.
    </Flex>
  );
};
